import { connect } from "react-redux";
import * as Redux from "redux";
import StageTwo from "./component";

import {
  // Endpoints
  toggleSftp,
  toggleEmail,
  toggleFtp,
  editEndpoint,
  // Schedule
  toggleDaily,
  toggleWeekly,
  toggleMonthly,
  toggleEnabled,
  editStart,
  editDay,
  editTimezone,
  editTime,
  // Contacts
  editContacts
} from "../../actions";

const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    schedule: {
      type: state.reportForm.schedule.type,
      day: state.reportForm.schedule.day,
      time: state.reportForm.schedule.time,
      timezone: state.reportForm.schedule.timezone,
      start: state.reportForm.schedule.start,
      enabled: state.reportForm.schedule.enabled
    },
    endpoint: state.reportForm.endpoint,
    contacts: state.reportForm.contacts,
    next: ownProps.next
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>): any => {
  return {
    ...Redux.bindActionCreators(
      {
        // Schedule
        toggleDaily,
        toggleWeekly,
        toggleMonthly,
        editDay,
        editTime,
        editStart,
        editTimezone,
        toggleEnabled,
        // Endpoints
        toggleSftp,
        toggleEmail,
        toggleFtp,
        editEndpoint,
        // Contacts
        editContacts
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StageTwo);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/container.ts